/// <amd-module name="Environments/EnvironmentTraceabilityWorkItems/Stores/WorkitemsStore" />
import { IWorkitemsResult, WorkItemRef } from "Environments/Client/EnvironmentContracts";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { WorkitemsActions } from "Environments/EnvironmentTraceabilityWorkItems/Actions/WorkitemsActions";
import { StoreBase } from "Environments/Flux/Store";
import { WorkItemType } from "Environments/RemoteClients/Contracts/WorkItemTracking";

export class WorkitemsStore extends StoreBase {

    public static getKey(): string {
        return "workitems-store";
    }
    
    public initialize(instanceId: string): void {
        super.initialize(instanceId);
        this._state = {
            workitems: [],
            icons: []
        }

        this._actionsHub = ActionsHubManager.GetActionsHub<WorkitemsActions>(WorkitemsActions, instanceId);
        this._actionsHub.setWorkitems.addListener(this._handleSetWorkitems);
        this._actionsHub.setIcons.addListener(this._handleSetIcons);
    }

    public getState(): IWorkitemsResult {
        return this._state;
    }

    public getWorkitems(): WorkItemRef[] {
        return this._state.workitems ? this._state.workitems : [];
    }

    public getIcons(): WorkItemType[] {
        return this._state.icons ? this._state.icons : [];
    }
    
    protected disposeInternal(): void {
        this._actionsHub.setWorkitems.removeListener(this._handleSetWorkitems);
    }

    private _handleSetWorkitems = (workitemsResult: IWorkitemsResult) => {
        if (workitemsResult) {
            this._state.workitems = workitemsResult.workitems || [];            
            this.emitChanged();
        }
    }

    private _handleSetIcons = (workItemTypes: WorkItemType[]) => {
        if(workItemTypes) { 
            this._state.icons = workItemTypes;
            this.emitChanged();
        }
    }

    private _actionsHub: WorkitemsActions;
    private _state: IWorkitemsResult;
}
